
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';
import { QuestionCategoryType } from 'enums/QuestionCategoryType';
import { ReplyType } from 'enums/ReplyType';
import { CompanyModel } from './Entities.GormCrm.Company';
import { QuestionTagModel } from './Entities.GormCrm.QuestionTag';


export class QuestionnaireViewModel extends Model<QuestionnaireViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'questionnaireView.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'questionnaireView.property.name' },
		{ name: 'questionCategories', type: 'QuestionCategoryViewModel[]', languageString: 'questionnaireView.property.questionCategories', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionCategoryViewModel }, properties: () => { return QuestionCategoryViewModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public questionCategories: QuestionCategoryViewModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.questionCategories = [];
		
	}
	getProperties(){
		return QuestionnaireViewModel.classProperties;
	}
}
export class QuestionnaireQuestionReplyViewModel extends Model<QuestionnaireQuestionReplyViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionnaireId', type: 'guid', languageString: 'questionnaireQuestionReplyView.property.questionnaireId' },
		{ name: 'questionId', type: 'guid', languageString: 'questionnaireQuestionReplyView.property.questionId' },
		{ name: 'required', type: 'boolean', languageString: 'questionnaireQuestionReplyView.property.required' },
		{ name: 'sortOrder', type: 'number', languageString: 'questionnaireQuestionReplyView.property.sortOrder' },
		{ name: 'questionnaireName', type: 'string', languageString: 'questionnaireQuestionReplyView.property.questionnaireName' },
		{ name: 'category', type: 'QuestionCategoryType', languageString: 'questionnaireQuestionReplyView.property.category' },
		{ name: 'questionText', type: 'string', languageString: 'questionnaireQuestionReplyView.property.questionText' },
		{ name: 'questionReplyInputType', type: 'ReplyType', languageString: 'questionnaireQuestionReplyView.property.questionReplyInputType' },
		{ name: 'requiredNumberOfReplies', type: 'number', languageString: 'questionnaireQuestionReplyView.property.requiredNumberOfReplies' },
		{ name: 'companyId', type: 'guid', languageString: 'questionnaireQuestionReplyView.property.companyId' },
		{ name: 'orderId', type: 'guid', languageString: 'questionnaireQuestionReplyView.property.orderId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'questionnaireQuestionReplyView.property.taskflowId' },
		{ name: 'productId', type: 'guid', languageString: 'questionnaireQuestionReplyView.property.productId' },
		{ name: 'productVariantId', type: 'guid', languageString: 'questionnaireQuestionReplyView.property.productVariantId' },
		{ name: 'groupQuestions', type: 'boolean', languageString: 'questionnaireQuestionReplyView.property.groupQuestions' },
		{ name: 'productName', type: 'string', languageString: 'questionnaireQuestionReplyView.property.productName' },
		{ name: 'productTag', type: 'string', languageString: 'questionnaireQuestionReplyView.property.productTag' },
		{ name: 'orderLineId', type: 'guid', languageString: 'questionnaireQuestionReplyView.property.orderLineId' },
		{ name: 'variantName', type: 'string', languageString: 'questionnaireQuestionReplyView.property.variantName' }
	];
	[key: string]: any;
	
	public questionnaireId?: string;
	public questionId?: string;
	public required?: boolean;
	public sortOrder?: number;
	public questionnaireName: string;
	public category: QuestionCategoryType;
	public questionText: string;
	public questionReplyInputType?: ReplyType;
	public requiredNumberOfReplies: number;
	public companyId?: string;
	public orderId?: string;
	public taskflowId?: string;
	public productId?: string;
	public productVariantId?: string;
	public groupQuestions?: boolean;
	public productName: string;
	public productTag: string;
	public orderLineId?: string;
	public variantName: string;
    
	constructor(){
		super();
		this.questionnaireId = undefined;
		this.questionId = undefined;
		this.required = undefined;
		this.sortOrder = undefined;
		this.questionnaireName = '';
		this.category = 0;
		this.questionText = '';
		this.questionReplyInputType = undefined;
		this.requiredNumberOfReplies = 0;
		this.companyId = undefined;
		this.orderId = undefined;
		this.taskflowId = undefined;
		this.productId = undefined;
		this.productVariantId = undefined;
		this.groupQuestions = undefined;
		this.productName = '';
		this.productTag = '';
		this.orderLineId = undefined;
		this.variantName = '';
		
	}
	getProperties(){
		return QuestionnaireQuestionReplyViewModel.classProperties;
	}
}
export class QuestionCategoryViewModel extends Model<QuestionCategoryViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'categoryType', type: 'QuestionCategoryType', languageString: 'questionCategoryView.property.categoryType' },
		{ name: 'questionGroups', type: 'QuestionGroupViewModel[]', languageString: 'questionCategoryView.property.questionGroups', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionGroupViewModel }, properties: () => { return QuestionGroupViewModel.classProperties } }
	];
	[key: string]: any;
	
	public categoryType: QuestionCategoryType;
	public questionGroups: QuestionGroupViewModel[];
    
	constructor(){
		super();
		this.categoryType = 0;
		this.questionGroups = [];
		
	}
	getProperties(){
		return QuestionCategoryViewModel.classProperties;
	}
}
export class QuestionGroupViewModel extends Model<QuestionGroupViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'company', type: 'CompanyModel', languageString: 'questionGroupView.property.company', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'companyId', type: 'guid', languageString: 'questionGroupView.property.companyId' },
		{ name: 'orderId', type: 'guid', languageString: 'questionGroupView.property.orderId' },
		{ name: 'productId', type: 'guid', languageString: 'questionGroupView.property.productId' },
		{ name: 'productVariantId', type: 'guid', languageString: 'questionGroupView.property.productVariantId' },
		{ name: 'groupQuestions', type: 'boolean', languageString: 'questionGroupView.property.groupQuestions' },
		{ name: 'productName', type: 'string', languageString: 'questionGroupView.property.productName' },
		{ name: 'productTags', type: 'string[]', languageString: 'questionGroupView.property.productTags', isArray: true },
		{ name: 'orderLineId', type: 'guid', languageString: 'questionGroupView.property.orderLineId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'questionGroupView.property.taskflowId' },
		{ name: 'variantName', type: 'string', languageString: 'questionGroupView.property.variantName' },
		{ name: 'questions', type: 'QuestionViewModel[]', languageString: 'questionGroupView.property.questions', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionViewModel }, properties: () => { return QuestionViewModel.classProperties } },
		{ name: 'id', type: 'number', languageString: 'questionGroupView.property.id', isHidden: true }
	];
	[key: string]: any;
	
	public company?: CompanyModel;
	public companyId?: string;
	public orderId?: string;
	public productId?: string;
	public productVariantId?: string;
	public groupQuestions: boolean;
	public productName: string;
	public productTags: string[];
	public orderLineId?: string;
	public taskflowId?: string;
	public variantName: string;
	public questions: QuestionViewModel[];
	public id: number;
    
	constructor(){
		super();
		this.company = undefined;
		this.companyId = undefined;
		this.orderId = undefined;
		this.productId = undefined;
		this.productVariantId = undefined;
		this.groupQuestions = false;
		this.productName = '';
		this.productTags = [];
		this.orderLineId = undefined;
		this.taskflowId = undefined;
		this.variantName = '';
		this.questions = [];
		this.id = 0;
		
	}
	getProperties(){
		return QuestionGroupViewModel.classProperties;
	}
}
export class QuestionViewModel extends Model<QuestionViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionId', type: 'guid', languageString: 'questionView.property.questionId' },
		{ name: 'required', type: 'boolean', languageString: 'questionView.property.required' },
		{ name: 'sortOrder', type: 'number', languageString: 'questionView.property.sortOrder' },
		{ name: 'questionCategory', type: 'QuestionCategoryType', languageString: 'questionView.property.questionCategory' },
		{ name: 'questionText', type: 'string', languageString: 'questionView.property.questionText' },
		{ name: 'questionReplyInputType', type: 'ReplyType', languageString: 'questionView.property.questionReplyInputType' },
		{ name: 'requiredNumberOfReplies', type: 'number', languageString: 'questionView.property.requiredNumberOfReplies' },
		{ name: 'replyData', type: 'ReplyViewModel[]', languageString: 'questionView.property.replyData', isHidden: true, isArray: true, isObject: true, new: () => { return new ReplyViewModel }, properties: () => { return ReplyViewModel.classProperties } },
		{ name: 'questionTags', type: 'QuestionTagModel[]', languageString: 'questionView.property.questionTags', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionTagModel }, properties: () => { return QuestionTagModel.classProperties } }
	];
	[key: string]: any;
	
	public questionId?: string;
	public required: boolean;
	public sortOrder?: number;
	public questionCategory: QuestionCategoryType;
	public questionText: string;
	public questionReplyInputType: ReplyType;
	public requiredNumberOfReplies: number;
	public replyData: ReplyViewModel[];
	public questionTags: QuestionTagModel[];
    
	constructor(){
		super();
		this.questionId = undefined;
		this.required = false;
		this.sortOrder = undefined;
		this.questionCategory = 0;
		this.questionText = '';
		this.questionReplyInputType = 0;
		this.requiredNumberOfReplies = 0;
		this.replyData = [];
		this.questionTags = [];
		
	}
	getProperties(){
		return QuestionViewModel.classProperties;
	}
}
export class ReplyViewModel extends Model<ReplyViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'replyId', type: 'guid', languageString: 'replyView.property.replyId' },
		{ name: 'replies', type: 'string', languageString: 'replyView.property.replies' },
		{ name: 'companyId', type: 'guid', languageString: 'replyView.property.companyId' },
		{ name: 'orderId', type: 'guid', languageString: 'replyView.property.orderId' },
		{ name: 'orderLineId', type: 'guid', languageString: 'replyView.property.orderLineId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'replyView.property.taskflowId' }
	];
	[key: string]: any;
	
	public replyId?: string;
	public replies: string;
	public companyId?: string;
	public orderId?: string;
	public orderLineId?: string;
	public taskflowId?: string;
    
	constructor(){
		super();
		this.replyId = undefined;
		this.replies = '';
		this.companyId = undefined;
		this.orderId = undefined;
		this.orderLineId = undefined;
		this.taskflowId = undefined;
		
	}
	getProperties(){
		return ReplyViewModel.classProperties;
	}
}

